"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M9.8.15l5.1 2.6c.7.3 1.1 1 1.1 1.8v6.8c0 .8-.5 1.6-1.3 1.9l-6.9 2.6c-.5.2-1.1.2-1.6 0l-5.1-2.6c-.7-.3-1.1-1-1.1-1.8v-6.8c0-.8.5-1.6 1.3-1.9L8.2.15c.5-.2 1.1-.2 1.6 0zM12 6.193V9.9l-2 .8V6.943l-2 .75v6.018l6-2.261V5.443l-2 .75z"];
//# sourceMappingURL=package.js.map